(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("MobileCheck", [], factory);
	else if(typeof exports === 'object')
		exports["MobileCheck"] = factory();
	else
		root["MobileCheck"] = factory();
})(window, function() {
return 